export default "__VITE_ASSET__C7JZjzT0__"